/* eslint-disable @typescript-eslint/no-explicit-any */
import { HTTPInstance } from './http-instance'

function getRestaurantId(): string {
  const id = localStorage.getItem('restaurantId')
  if (!id) {
    throw new Error('No restaurantId found in localStorage')
  }
  return id
}

function withRestaurantPrefix(path: string): string {
  return `/restaurants/${getRestaurantId()}${
    path.startsWith('/') ? path : `/${path}`
  }`
}

export const HTTPInstanceWithPrefix = {
  get: <T = any>(path: string, config?: any) =>
    HTTPInstance.get<T>(withRestaurantPrefix(path), config),

  post: <T = any>(path: string, data?: any, config?: any) =>
    HTTPInstance.post<T>(withRestaurantPrefix(path), data, config),

  put: <T = any>(path: string, data?: any, config?: any) =>
    HTTPInstance.put<T>(withRestaurantPrefix(path), data, config),

  delete: <T = any>(path: string, config?: any) =>
    HTTPInstance.delete<T>(withRestaurantPrefix(path), config)
}
